<template>
  <div id="search">
    <div id="search-control">
      <input id="search-input" :class="{ active: showTagsPanel }" type="text" placeholder="Search for tags" v-model="searchTerm" @keyup="handleSearchType" />
      <div id="tag-list" v-show="showTagsPanel">
        <p v-show="!foundTags.length"><em>No tags found</em></p>
        <ul v-show="foundTags.length">
          <li v-for="tag in foundTags"><a href="" class="found-tag" @click.prevent="handleTagClick(tag)">{{ tag }}</a></li>
        </ul>
      </div>
    </div>
    <ul id="active-tag-list">
      <li v-for="activeTag in activeTags"><a href="" class="active-tag-cancel" @click.prevent="removeTag(activeTag)">x</a> {{ activeTag }}</li>
    </ul>
  </div>
</template>

<style scoped lang="scss">

  #search {
    height: 112px;
    padding: 6px 24px 24px;

    #search-control {
      position: relative;
      width: 240px;
      margin: 0 auto;

      #search-input {
        padding: 10px 18px;
        width: 240px;
        border-radius: 6px;
        border: 1px solid grey;
        outline: none;

        &.active {
          border-radius: 6px 6px 0px 0px;
        }
      }

      #tag-list {
        position: absolute;
        top: 38px;
        z-index: 9999;
        width: 240px;
        margin-top: 0;
        background-color: white;
        padding: 8px;
        border-color: grey;
        border-style: solid;
        border-width: 0px 1px 1px 1px;
        border-radius: 0px 0px 6px 6px;

        ul {
          list-style-type: none;
          margin: 0;
          padding: 0;
        }

        p {
          margin: 0;
        }
      }
    }

    ul#active-tag-list {
      list-style-type: none;
      padding: 0 12px;

      li {
        display: inline-block;
        margin-right: 8px;
        padding: 3px 8px;
        border: 1px solid grey;
        border-radius: 6px;
      }
    }
  }

</style>

<script>
export default {
  name: 'Search',

  props:[ 'searchTags', 'urlTerms' ],

  data: () => ({
    searchTerm: '',
    foundTags: [],
    showTagsPanel: false,
    activeTags: []
  }),

  methods: {
    handleSearchType() {
      this.showTagsPanel = false

      if (this.searchTerm.length > 2) {
        this.showTagsPanel = true
      }

      this.foundTags = this.searchTags.filter((t) => {
        const ci_tag = t.toLowerCase()
        return ci_tag.includes(this.searchTerm.toLowerCase())
      })
    }, 

    handleTagClick(tag) {
      if (this.searchTags.indexOf(tag) < 0) {
        return
      }

      if (this.activeTags.indexOf(tag) == -1) {
        this.activeTags.push(tag)
        this.foundTags.splice(this.foundTags.indexOf(tag), 1)
        this.clearSearch()
        this.updateURL()
      }
    },

    removeTag(activeTag) {
      this.activeTags.splice(this.activeTags.indexOf(activeTag), 1)
      this.handleSearchType()
      this.updateURL()
    },

    updateURL() {
      let urlParams = encodeURIComponent(this.activeTags.join('|'))
      this.$router.push({path: `/${urlParams}`})
    },

    clearSearch() {
      this.searchTerm = ''
      this.foundTags = []
      this.showTagsPanel = false
    },

    setURLTerms() {
      if (!this.urlTerms) {
        this.activeTags = []
        return
      }

      let terms = decodeURIComponent(this.urlTerms).split('|');

      this.activeTags = terms.filter((t) => {
        return (this.searchTags.indexOf(t) >= 0)
      })
    }
  },

  watch: {
    searchTags() {
      this.setURLTerms()
    },

    urlTerms() {
      this.setURLTerms()
    }
  },

  computed: {

  },

  created() {

  },

  mounted() {
    this.setURLTerms()
  }
}
</script>